import { render, staticRenderFns } from "./yuyi-tree.vue?vue&type=template&id=01764842&scoped=true&"
import script from "./yuyi-tree.vue?vue&type=script&lang=ts&"
export * from "./yuyi-tree.vue?vue&type=script&lang=ts&"
import style0 from "./yuyi-tree.vue?vue&type=style&index=0&id=01764842&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01764842",
  null
  
)

export default component.exports